module.exports = __webpack_public_path__ + "static/media/waa.06b38283.ogg";